import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Input } from '../../Form/Form'
import Button from 'react-bootstrap/Button'
import Controllers from '../../../Api/Controllers'
import { toast } from 'react-toastify'
import Box from './Styled/Box'
import { useMemo } from 'react'
import Helpers from '../../Helpers/Helpers'
import { useHistory } from 'react-router-dom'

const RecoveryPassword = () => {
  const { token } = useParams()
  const [isValid, setIsValid] = useState(null)
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)

  const type = 'empresariosindependientes'

  const history = useHistory()

  useEffect(() => {
    Controllers.users.validate_recovery_code({ p_code: token }).then(res => {
      setIsValid(res.response === 'success')
    }).catch(() => {
      setIsValid(false)
    })
  }, [token])

  const handleChangePassword = (e) => {
    e.preventDefault()

    if (password !== confirm) {
      Helpers.toast.construct({
        response: 'warning',
        message: 'Las contraseñas no coinciden',
        toast
      })
      return
    }

    setLoading(true)

    Controllers.users.reset_password({ p_code: token, p_new_password: password })
      .then(res => {
        Helpers.toast.construct({ ...res, toast })

        if (res.response === 'success') {
          history.push(Helpers.config.convertUrl({ url: '/login/empresariosindependientes' }))
        }
      })
      .catch(req => {
        Helpers.promise.catch({ req, toast })
      })
      .finally(() => setLoading(false))
  }

  const imageBackground = useMemo(() => {
    return Helpers.config.resourcesUrl({ url: '/images/dashboard/system-devs-login-background-v2.png?v=2' })
  }, [type])

  if (isValid === null) return <p className="text-center mt-5">Verificando enlace...</p>
  if (isValid === false) return <>
    <p className="text-center mt-5 text-danger">El código no es válido o ha expirado.</p>
  </>

  return (
    <>
      <div style={{
        position: 'fixed',
        height: '100%',
        width: '100%',
        background: 'linear-gradient(118deg, #c4d8e8, #a7b1c1)'
      }}></div>
      <Box backgroundImage={imageBackground}>
        <Box.Container>
          <Box.Content className="form-row modern-auth-card">
            <div className="col-12 text-center mb-4">
              <div className="system-devs-auth-brand"><span>SD</span><strong>System Devs</strong></div>
            </div>
            <form onSubmit={handleChangePassword} className="col-12 needs-validation" noValidate>
              <h3 className="text-center mb-4">Restablecer contraseña</h3>
              <Input
                type="password"
                placeholder="Nueva contraseña"
                icon="fa fa-lock"
                classNameParent="mb-3"
                required
                value={password}
                onChange={e => setPassword(e.currentTarget.value)}
              />
              <Input
                type="password"
                placeholder="Confirmar contraseña"
                icon="fa fa-lock"
                classNameParent="mb-3"
                required
                value={confirm}
                onChange={e => setConfirm(e.currentTarget.value)}
              />
              <Button type="submit" variant="success" block disabled={loading}>
                {loading ? <i className="fa fa-circle-notch fa-spin" /> : 'Guardar nueva contraseña'}
              </Button>
            </form>
          </Box.Content>
        </Box.Container>
      </Box>
    </>
  )
}

export default RecoveryPassword
